export default __webpack_public_path__ + "static/media/property_895.82e177e7.png";